module.exports = __webpack_public_path__ + "static/media/8900_UpperBathroom.2045c5d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_UpperBathroom.jpg
// module id = 583
// module chunks = 0